import type { TerminationReason } from "src/clients/agent-management";

const reasonMap: Record<TerminationReason, string> = {
  expired: "Session expired",
  invocation_runtime_limit: "Runtime limit exceeded",
  model_call_limit:
    "Model call limit exceeded — consider increasing 'Max iterations' in execution settings",
  tool_call_limit:
    "Tool call limit exceeded — consider increasing 'Max iterations' in execution settings",
  infinite_tool_loop: "Infinite tool loop detected",
  recursion_limit_exceeded: "Recursion limit exceeded",
  repetitive_text_output: "Repetitive text output detected",
  error: "Internal error",
  user_cancelled: "Cancelled by user",
  upstream_cancelled: "Cancelled upstream",
  version_diverged: "Version diverged",
  quota_exhausted: "Monthly token quota/cost limit exhausted",
  rate_limit_exceeded: "Request/token rate limit exceeded",
  redrive_limit_exceeded: "Redrive limit exceeded",
  llm_provider_bad_request: "LLM provider bad request",
  llm_provider_rate_limit: "LLM provider rate limit exceeded",
  llm_provider_byok_auth_error: "LLM provider authentication error",
  llm_provider_context_window_exceeded: "LLM provider context window exceeded",
  tool_execution_error: "Tool execution error",
  tool_auth_error: "Tool authentication error",
  tool_discovery_error: "Tool discovery error",
  tool_rate_limit_exceeded: "Tool rate limit exceeded",
  tool_request_timeout: "Tool request timed out",
  file_not_found: "File not found",
  flow_version_not_found: "Flow version not found",
};

export const formatTerminationReason = (reason: TerminationReason): string =>
  reasonMap[reason] ?? reason;
